import type { CursorPage } from '../../api/contract';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  CommissionAdjustmentInput,
  CommissionAdjustmentPreview,
  CommissionLedgerEntry,
  CommissionLedgerEntryDetail,
  CommissionLedgerListQuery,
  MockApprovalRequest,
} from './types';

export interface CommissionLedgerReadRepository {
  list(
    query: CommissionLedgerListQuery,
    signal: AbortSignal,
  ): Promise<CursorPage<CommissionLedgerEntry>>;
  get(entryId: string, signal: AbortSignal): Promise<CommissionLedgerEntryDetail>;
}

export interface CommissionLedgerRepository extends CommissionLedgerReadRepository {
  previewMockAdjustment(input: CommissionAdjustmentInput): Promise<CommissionAdjustmentPreview>;
  submitMockAdjustment(input: CommissionAdjustmentInput): Promise<MockApprovalRequest>;
}

export const commissionLedgerRepositoryToken =
  createRepositoryToken<CommissionLedgerReadRepository>('commissionLedger');

export const defaultCommissionLedgerListQuery = Object.freeze<CommissionLedgerListQuery>({
  cursor: '',
  pageSize: 25,
  sort: 'effectiveAt',
  filters: {
    partnerId: '',
    agentId: '',
    beneficiaryType: '',
    beneficiaryId: '',
    beneficiaryUsername: '',
    transactionId: '',
    partnerTransactionId: '',
    entryType: '',
    currency: '',
    minimumAmount: '',
    maximumAmount: '',
    effectiveFrom: '',
    effectiveTo: '',
  },
});

export function hasMockAdjustments(
  repository: CommissionLedgerReadRepository,
): repository is CommissionLedgerRepository {
  const candidate = repository as Partial<CommissionLedgerRepository>;
  return (
    typeof candidate.previewMockAdjustment === 'function' &&
    typeof candidate.submitMockAdjustment === 'function'
  );
}
